/**
 * Validate event data
 * @param {Object} data - Event data to validate
 * @returns {Object} Validation result with isValid flag and errors object
 */
export const validateEventData = (data) => {
  const errors = {};

  // Title validation
  if (!data.title || data.title.trim().length === 0) {
    errors.title = 'Event title is required';
  } else if (data.title.length > 100) {
    errors.title = 'Event title must be less than 100 characters';
  }

  // Date validation
  if (!data.date) {
    errors.date = 'Event date is required';
  } else {
    const eventDate = new Date(data.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (isNaN(eventDate.getTime())) {
      errors.date = 'Invalid date format';
    } else if (eventDate < today) {
      errors.date = 'Event date cannot be in the past';
    }
  }

  // Location validation
  if (!data.location || data.location.trim().length === 0) {
    errors.location = 'Location is required';
  }

  // Description validation
  if (data.description && data.description.length > 1000) {
    errors.description = 'Description must be less than 1000 characters';
  }

  // Time validation
  if (data.time && !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(data.time)) {
    errors.time = 'Invalid time format (use HH:MM)';
  }

  // Capacity validation
  if (data.capacity && isNaN(Number(data.capacity.replace(/\D/g, '')))) {
    errors.capacity = 'Capacity must be a valid number';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

/**
 * Validate a single field
 * @param {string} field - Field name
 * @param {any} value - Field value
 * @returns {string|null} Error message or null if valid
 */
export const validateField = (field, value) => {
  switch (field) {
    case 'title':
      if (!value || value.trim().length === 0) {
        return 'Event title is required';
      }
      if (value.length > 100) {
        return 'Event title must be less than 100 characters';
      }
      return null;

    case 'date':
      if (!value) {
        return 'Event date is required';
      }
      const eventDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (isNaN(eventDate.getTime())) {
        return 'Invalid date format';
      }
      if (eventDate < today) {
        return 'Event date cannot be in the past';
      }
      return null;

    case 'location':
      if (!value || value.trim().length === 0) {
        return 'Location is required';
      }
      return null;

    case 'description':
      if (value && value.length > 1000) {
        return 'Description must be less than 1000 characters';
      }
      return null;

    case 'time':
      if (value && !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)) {
        return 'Invalid time format (use HH:MM)';
      }
      return null;

    default:
      return null;
  }
};

